import React, { useEffect, useState } from "react";

const Preloader = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Hide preloader after component mounts
    const timer = setTimeout(() => {
      setIsVisible(false);
      document.body.classList.add("page-loaded");
    }, 500);

    // Also handle window load event for initial page load
    const handlePreloader = () => {
      setIsVisible(false);
      document.body.classList.add("page-loaded");
    };

    if (document.readyState === "complete") {
      // Page already loaded
      handlePreloader();
    } else {
      window.addEventListener("load", handlePreloader);
    }

    return () => {
      clearTimeout(timer);
      window.removeEventListener("load", handlePreloader);
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="preloader" style={{ opacity: isVisible ? 1 : 0 }}>
      <div className="clear-loading loading-effect-2">
        <span></span>
      </div>
    </div>
  );
};

export default Preloader;
